// extracted by mini-css-extract-plugin
export default {"image":"WidgetImage_image__nvMAe"};